export async function getJson(jsonFilePath, method = "GET", jsonData = null) {
	try {
		// Dispatch 'get-json-start' event
		const startEvent = new CustomEvent("get-json-start", { detail: { jsonFilePath } });
		window.dispatchEvent(startEvent);

		// Prepare the fetch options
		const fetchOptions = {
			method,
			headers: {
				"Content-Type": "application/json",
			},
		};

		// If method is POST, add body to the request
		if (method === "POST" && jsonData) {
			fetchOptions.body = JSON.stringify(jsonData);
		}

		//console.log("get-json-start: "+jsonFilePath);
		const response = await fetch(jsonFilePath, fetchOptions);

		// Check if the response is not successful (status code outside 200-299)
		if (!response.ok) {
			// Try to parse and return the error response as JSON
			const errorResponse = await response.json();
			//console.error("Response error:", errorResponse);

			if (errorResponse.code == 401) {
				// Dispatch 'get-json-end' event with error details
				const endEvent = new CustomEvent("get-json-end", { detail: { status: "error", error: errorResponse } });
				window.dispatchEvent(endEvent);

				alert("Timeout or Unauthorized Access");
				location.reload();
			}
			return errorResponse;
		}

		const res = await response.json();

		// Dispatch 'get-json-end' event with success details
		const endEvent = new CustomEvent("get-json-end", { detail: { status: "success", data: res } });
		window.dispatchEvent(endEvent);

		return res;
	} catch (error) {
		// Handle network or other errors
		const endEvent = new CustomEvent("get-json-end", { detail: { status: "error", error: error } });
		window.dispatchEvent(endEvent);

		console.error("getJson error:", error);

		return { status: "system-error", message: error.message };
	}
}

export function formatFileSize(size) {
	if (size < 0) return "Invalid size";
	if (size === 0) return "0 bytes";

	const units = ["bytes", "KB", "MB", "GB", "TB"];
	let unitIndex = 0;

	while (size >= 1024 && unitIndex < units.length - 1) {
		size /= 1024;
		unitIndex++;
	}

	return `${size.toFixed(2)} ${units[unitIndex]}`;
}

export function hl(text, term = null) {
	text = String(text ?? "");
	// console.log("hl:",text,term);
	if (!term.trim()) return text;
	const searchTerm = term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	const regex = new RegExp(`(${searchTerm})`, "gi");
	return text.replace(regex, "<mark>$1</mark>");
}

export function slugify(text) {
	return (
		text
			//.normalize("NFKD") // Normalize Unicode
			.replace(/["“”‘’«»()]/g, "") // Remove smart quotes
			// .replace(/[^\p{L}\p{N}\s]+/gu, "") // Remove all punctuation except letters/numbers/spaces
			.trim()
			.replace(/\s+/g, "-") // Replace spaces with -
			.toLowerCase()
	);
}

export function getParentFolder(path, root = "/") {
	// Ensure root ends with /
	root = root.endsWith("/") ? root : root + "/";

	// Remove trailing slash if present
	path = path.endsWith("/") ? path.slice(0, -1) : path;

	// Prevent going higher than root
	if (path === root.slice(0, -1)) return root;

	// Find last slash position
	const idx = path.lastIndexOf("/");

	if (idx === -1) return root;

	const parent = path.slice(0, idx + 1);

	// Ensure we don't go above root
	return parent.length < root.length ? root : parent;
}

export function timeAgo(dateStr) {
	const now = new Date();
	const targetDate = new Date(dateStr);

	const diffMs = now - targetDate; // Difference in milliseconds
	const diffSec = Math.max(0, Math.floor(diffMs / 1000));
	const diffMin = Math.floor(diffSec / 60);
	const diffHour = Math.floor(diffMin / 60);
	const diffDay = Math.floor(diffHour / 24);

	// Helper to format time (HH:mm)
	const formatTime = (date) => `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;

	if (diffMin < 1) {
		return `${diffSec} sec ago`;
	} else if (diffHour < 1) {
		return `${diffMin} min ago`;
	} else if (diffDay < 1) {
		return `${diffHour} hours ago`;
	} else if (diffDay === 1) {
		return `Yesterday at ${formatTime(targetDate)}`;
	} else if (diffDay < 7) {
		return `${diffDay} days ago at ${formatTime(targetDate)}`;
	} else {
		// Format for more than a week ago (Month Day, Year at HH:mm)
		return targetDate.toLocaleString("en-US", {
			year: "numeric",
			month: "long",
			day: "numeric",
			hour: "numeric",
			minute: "numeric",
			hour12: true,
		});
	}
}

export function dirPath(path, file) {
	return path.substring(0, path.lastIndexOf(file));
}

export function rootUrl() {
	return window.location.protocol + "//" + window.location.host;
}

export function short_uid(len = 6) {
	return (Math.random().toString(36).slice(2)).slice(-len);
}
